<template>
    <div class="main-container custom—scrollbar">
        <div class="inner-container">
            <div class="select-container">
                <el-select v-model="currentArea.areaCode" @change="loadData" placeholder="请选择">
                    <el-option
                        v-for="(areaItem, index) in areaList"
                        :key="index"
                        :label="areaItem.areaName"
                        :value="areaItem.areaCode">
                    </el-option>
                </el-select>
            </div>
            <div class="title">
                <span class="color-block"></span>
                <span>总览</span>
            </div>
            <div class="section general-accounting-container">
                <div class="general-accounting-item">
                    <div class="general-accounting-item__count">{{generalInfo.allVisitorNum}}</div>
                    <div class="general-accounting-item__desc">观看总人次</div>
                </div>
                <div class="general-accounting-item">
                    <div class="general-accounting-item__count">{{generalInfo.resourceCount}}</div>
                    <div class="general-accounting-item__desc">资源总数</div>
                </div>
                <div class="general-accounting-item">
                    <div class="general-accounting-item__count">{{generalInfo.dayVisitorNum}}</div>
                    <div class="general-accounting-item__desc">今日观看人次</div>
                </div>
                <div class="general-accounting-item">
                    <div class="general-accounting-item__count">{{generalInfo.weekVisitorNum}}</div>
                    <div class="general-accounting-item__desc">本周观看人次</div>
                </div>
                <div class="general-accounting-item">
                    <div class="general-accounting-item__count">{{generalInfo.monthVisitorNum}}</div>
                    <div class="general-accounting-item__desc">本月观看人次</div>
                </div>
            </div>
            <div class="title">
                <span class="color-block"></span>
                <span>访问曲线</span>
            </div>
            <div class="section access-accounting">
                <el-radio-group @change="searchCurve" v-model="accessQuery.searchType" size="small">
                    <el-radio-button label="7">7天</el-radio-button>
                    <el-radio-button label="14">14天</el-radio-button>
                    <el-radio-button label="30">30天</el-radio-button>
                </el-radio-group>
                <el-date-picker
                    v-model="accessDateDuration"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="small"
                >
                </el-date-picker>
                <el-button type="primary" @click="searchCurve(0)" size="small">搜索</el-button>
                <div class="access-chart" id="access-chart"></div>
            </div>
            <div class="title">
                <span class="color-block"></span>
                <span>各校访问统计</span>
            </div>
            <div class="section accounting-by-school">
                <div>
                    <el-radio-group @change="schoolTypeChange" v-model="schoolType" size="small">
                        <el-radio-button v-for="(periodItem, index) in schoolPeriodList" :key="index" :label="periodItem.code">
                            {{periodItem.value}}
                        </el-radio-button>
                    </el-radio-group>
                </div>
                <el-table
                    :data="accountingBySchoolData"
                    border
                    style="width: 100%"
                >
                    <el-table-column
                        label="学校名称"
                        show-overflow-tooltip
                        :resizable="false"
                        prop="schoolName"
                    >
                    </el-table-column>
                    <el-table-column
                        label="老师访问总次数"
                        align="center"
                        width="250px"
                        :resizable="false"
                        prop="thVisitorNum"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="stuVisitorNum"
                        label="学生家长访问总次数"
                        align="center"
                        width="250px"
                        :resizable="false"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="allVisitorNum"
                        label="访问总次数"
                        align="center"
                        width="250px"
                        :resizable="false"
                    >
                    </el-table-column>

                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import echarts from 'echarts';
    import baseMixin from '@/mixins/baseMixin.js';
    import {
        getAreaResourceStaticsDataInfo,
        getAreaResourceSchoolReadDataList,
        getAreaResourceReadCurveDataList,
        getUserStaticAreaCodeList
    } from '@/api/accounting/accounting';
    import { findDicsByCode } from '@/api/common/common';

    function drawLineChart(args) {
        const chart = echarts.init(document.getElementById('access-chart'));
        const option = {
            title: {
                text: '观看量统计图'
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data:['老师','学生家长']
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: args.xAxisData
            },
            yAxis: {
                name: '人次',
                type: 'value'
            },
            series: [
                {
                    name:'老师',
                    type:'line',
                    data: args.thVisitorNum
                },
                {
                    name:'学生家长',
                    type:'line',
                    data: args.stuVisitorNum
                }
            ],
            dataZoom: {
                zoomLock: true,
                show: false,
                realtime: true,
                start: 0,
                end: 100
            },
        };
        chart.setOption(option);
    }

    export default {
        name: "dataAccounting",
        data() {
            return {
                areaList: [],
                generalInfo: {
                    allVisitorNum: 0,
                    dayVisitorNum: 0,
                    monthVisitorNum: 0,
                    resourceCount: 0,
                    weekVisitorNum: 0
                },
                schoolPeriodList: [],
                schoolType: null,

                accessQuery: {
                    searchType: 7,
                    startTime: '',
                    endTime: '',
                    areaCode: 0
                },
                accessDateDuration: [],
                accountingBySchoolData: [],
                currentArea: {
                    areaCode: 0
                }
            }
        },
        mixins: [baseMixin],
        created() {
            getUserStaticAreaCodeList()
                .then(res => res.data)
                .then(data => {
                    this.currentArea.areaCode = data.data[0].areaCode;
                    this.areaList = data.data;
                    this.getAreaResourceStaticsDataInfoFunc();
                    findDicsByCode({
                        dicCode: 'schoolPeriodType'
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.data.length > 0) {
                                this.schoolPeriodList = data.data.filter(item => item.code !== '0');
                                this.schoolType = data.data[0].code;
                                this.getAreaResourceSchoolReadDataListFunc();
                            }
                        });
                    this.getAreaResourceReadCurveDataListFunc();
                })

        },
        methods: {
            loadData() {
                this.getAreaResourceStaticsDataInfoFunc();
                this.getAreaResourceSchoolReadDataListFunc();
                this.getAreaResourceReadCurveDataListFunc();
            },
            getAreaResourceStaticsDataInfoFunc() {
                getAreaResourceStaticsDataInfo({
                    areaCode: this.currentArea.areaCode
                })
                    .then(res => res.data)
                    .then(data => {
                        this.generalInfo = data.data;
                    });
            },
            getAreaResourceSchoolReadDataListFunc() {
                getAreaResourceSchoolReadDataList({
                    pageNo: 1,
                    pageSize: 1000,
                    searchType: this.schoolType,
                    areaCode: this.currentArea.areaCode
                })
                    .then(res => res.data)
                    .then(data => {
                        this.accountingBySchoolData = data.data.dataList;
                    })
            },
            schoolTypeChange(schoolType) {
                this.schoolType = schoolType;
                this.getAreaResourceSchoolReadDataListFunc();
            },
            searchCurve(searchType) {
                this.accessQuery.areaCode = this.currentArea.areaCode;
                if(searchType !== 0 || this.accessDateDuration === null || this.accessDateDuration.length !== 0) {
                    if(searchType === 0) {
                        this.accessQuery.startTime = moment(this.accessDateDuration[0]).format('YYYY-MM-DD');
                        this.accessQuery.endTime = moment(this.accessDateDuration[1]).format('YYYY-MM-DD');
                    } else {
                        this.accessQuery.startTime = '';
                        this.accessQuery.endTime = '';
                    }
                    this.accessQuery.searchType = searchType;
                    this.getAreaResourceReadCurveDataListFunc();
                } else {
                    this.$message({
                        message: '请选择日期',
                        type: 'error'
                    });
                }
            },
            getAreaResourceReadCurveDataListFunc() {
                this.accessQuery.areaCode = this.currentArea.areaCode;
                getAreaResourceReadCurveDataList(this.accessQuery)
                    .then(res => res.data)
                    .then(data => {
                        const args = {
                            xAxisData: [],
                            stuVisitorNum: [],
                            thVisitorNum: []
                        };
                        data.data.forEach(item => {
                            if(item !== null) {
                                args.xAxisData.push(item.readDate);
                                args.stuVisitorNum.push(item.stuVisitorNum);
                                args.thVisitorNum.push(item.thVisitorNum);
                            }
                        });
                        drawLineChart(args);
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin.scss";

    @include reset-global;

    .select-container {
        margin-bottom: 10px;
    }
    .title {
        font-size: 18px;
        & > * {
            @include middleIB;
        }
    }

    .color-block {
        @include wh(20px, 20px);
        background-color: #20a0ff;
        margin-right: 5px;
    }

    .main-container {
        width: 100%;
        .inner-container {
            width: 1320px;
            padding: 30px;
            min-height: 560px;
        }
    }

    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }

    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }

    .resource-info {
        text-align: right;
    }
    .section {
        margin: 20px 0;
    }
    .general-accounting-container {

        .general-accounting-item {
            @include middleIB;
            width: 160px;
            height: 100px;
            box-sizing: border-box;
            border: 2px solid #20a0ff;
            margin-right: 16px;
            text-align: center;
            padding-top: 20px;
            .general-accounting-item__count {
                font-size: 26px;
            }
            .general-accounting-item__desc {
                font-size: 16px;
            }
        }
    }
    .access-chart {
        width: 80%;
        height: 400px;
        margin: 5px 0;
    }
    .pagination-container {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/views/accounting/dataAccounting.vue